import { cn } from "cn";
import { Button } from "@/components/ui/button/button";
import { useResendTimer } from "@/hooks/use-resend-timer";

const RESEND_COOLDOWN_SECONDS = 60;

function formatCountdown(totalSeconds: number) {
  const minutes = Math.floor(totalSeconds / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (totalSeconds % 60).toString().padStart(2, "0");
  return `${minutes}:${seconds}`;
}

/** "Resend code in 00:42", flipping to a live Resend button once the cooldown ends. */
export function PresaleResendCode({ onResend }: { onResend: () => void }) {
  const { secondsLeft, isExpired, reset } = useResendTimer(
    RESEND_COOLDOWN_SECONDS,
  );

  return (
    <div className="mt-3 flex items-center text-sm">
      <span className="font-normal text-text-dark-high">
        {isExpired ? "Didn’t get a code?" : "Resend code in"}
      </span>
      <Button
        kind="soft"
        size="xs"
        onClick={() => {
          reset();
          onResend();
        }}
        disabled={!isExpired}
        className={cn(
          /* sorted */
          "ml-1 border-none",
          "text-sm font-normal text-text-dark-max",
          "bg-bg-dark-min",
        )}
      >
        {isExpired ? "Resend" : formatCountdown(secondsLeft)}
      </Button>
    </div>
  );
}
